import { GraphicElement } from './graphicelement';
export class Rectangle implements GraphicElement {
    public x: number;
    public y: number;
    public width: number;
    public height: number;
}
